<template>
<div>
  <head-nav :menuItems="menuItems" />
  <div class="seg-content general">

    <section class="teacher-list">
      <div class="teacher hl-wid ww1 wh1 wt0" v-for="(item, ii) in items">
        <div class="img"><div><img v-if="item.media" :src="photoLinkR(item.media, 400, 400, 'Fit')" /></div><span><img v-if="item.media" :src="photoLinkR(item.media, 400, 400, 'Fit')" /></span></div>
        <div class="details">
        <h2>{{ item.pubname || (item.firstname+" "+item.lastname) }}</h2>
        </div>
        <router-link :to="{name: 'content.teacher', params: {id: item.username}}" class="wlink"></router-link>
      </div>
    </section>
    
  </div>
</div>
</template>
<script>
import api from './api';
import moment from 'moment';
import mainNav from './mainNav';
 
export default {
  mixins: [mainNav],
  data: ()=>({
    items: [],
    categories: [],
    latestItems: [],
  }),
  methods: {
    photoLinkR(media, width, height, mode) {
      if (!media || !media.store || !media.store.rootUrl)
        return null;
      return '/api/Media/'+media.id+'/resize?w='+width+"&h="+height+"&m="+mode;
    },
    async loadItems() {
      var q={teacher: 1};
      var items=(await api.list("User", q, ["id:DESC"])).items;
      items.sort((a,b)=>{
        var titles=['Elder Master Teacher'];
        if (titles.indexOf(a.title)>titles.indexOf(b.title)) return -1;
        if (titles.indexOf(a.title)<titles.indexOf(b.title)) return 1;
        if (a.firstname<b.firstname) return -1;
        if (a.firstname>b.firstname) return 1;
        return 0;
      });
      this.items=items;
    },
    mediaUrl(obj) {
      if (!obj)
        return null;
      var rootUrl="";
      if (obj.store && obj.store.rootUrl)
        rootUrl=obj.store.rootUrl;
      if (obj.thumbnail)
        return rootUrl+obj.path.replace(/\/[^/]*$/, "/")+obj.thumbnail;
      else
        return rootUrl+obj.path;
    },
    introText(item) {
      var text=[item.pubdesc || ""];
      text=text.map((a)=>a.replace(/\<[^>]*\>/g, "").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, "\"").replace(/&[a-z]+;/g, ""));
      return text.join(" ").substring(0, 180);
    },
    formatDate(date, format) {
      return moment(date, "YYYY-MM-DD HH:mm:ss").format(format);
    },
  },
  mounted() {
    this.loadItems();
    this.loadTags();
    this.menuItems[4].active=true;
  },
}
</script>
